import { render, staticRenderFns } from "./pc.vue?vue&type=template&id=285c4f04&scoped=true"
import script from "./pc.vue?vue&type=script&lang=js"
export * from "./pc.vue?vue&type=script&lang=js"
import style0 from "./pc.vue?vue&type=style&index=0&id=285c4f04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "285c4f04",
  null
  
)

export default component.exports